var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Document"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    clipPath: "url(#clip-Document)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425",
    transform: "translate(-0.147 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M15.648,7H10.726A1.581,1.581,0,0,0,9.147,8.582V45.412a1.581,1.581,0,0,0,1.578,1.578h24.2a1.581,1.581,0,0,0,1.579-1.578V41.407H17.227a1.581,1.581,0,0,1-1.578-1.578Z",
    transform: "translate(0 0.207)",
    fill: "#1976d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M34.551,3.465A1.579,1.579,0,0,0,33.435,3H14.628A1.578,1.578,0,0,0,13.05,4.58V41.417a1.578,1.578,0,0,0,1.578,1.578H38.821A1.578,1.578,0,0,0,40.4,41.417V9.97a1.584,1.584,0,0,0-.463-1.117L34.551,3.465Z",
    transform: "translate(0.202)",
    fill: "#2196f3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M26.65,21.93a.632.632,0,1,1,1.094.632l-2.949,5.1a2.315,2.315,0,1,1-4.009-2.317L25,18.059a4,4,0,0,1,6.926,4l-4.634,8.018a1.054,1.054,0,0,0,1.822,1.053l4.634-8.018a6.1,6.1,0,0,0-10.57-6.109l-4.212,7.289a4.421,4.421,0,0,0,7.655,4.424l2.948-5.1a2.737,2.737,0,0,0-4.738-2.74A1.053,1.053,0,1,0,26.65,21.93Z",
    transform: "translate(0.477 0.567)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument1);
export default __webpack_public_path__ + "static/media/Document (1).fdaf8622.svg";
export { ForwardRef as ReactComponent };